import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var userDataEstas = localStorage.getItem("userDataEstas") ? JSON.parse(base64.decode(localStorage.getItem("userDataEstas"))) : "";
var serviceName = "controller";
var controllerService = {
    imageUrlBuyuk: WsProvider.resim+"/"+userDataEstas["firmaKodu"]+"/buyuk/",
    imageUrlOrta: WsProvider.resim+"/"+userDataEstas["firmaKodu"]+"/kucuk/",
    imageUrlKucuk: WsProvider.resim+"/"+userDataEstas["firmaKodu"]+"/enkucuk/",
    resimYukle(modul,name, base) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                modul: modul,
                name: name,
                base: base,
                methodName: "resimyukle",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    sunucuResim(modul) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                modul: modul,
                methodName: "sunucuResim",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    sunucuBelge(modul) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                modul: modul,
                methodName: "sunucuBelge",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    belgeYukle(modul,name, base) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                modul: modul,
                name: name,
                base: base,
                methodName: "belgeyukle",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    }
};
export default controllerService



